import React from "react";
import { Link } from "react-router-dom"
import Stepper from "../../../Components/Stepper/Stepper";
import BrandLogo from "../../../Components/BrandLogo/BrandLogo";

export default function Exercise(props) {
  const clickHandler = () => {
    props.onNext();
  };

  return (
    <div className="exercise bgContainer">
      <div className="blurOverlay">
        <BrandLogo />
        <h3 className="onboardingHeading">تمرین</h3>
        <h6 className="onboardingMessage exerciseMessage">
          تمرینات مقاومتی، کاردیو و ریکاوری. در هر زمان در هر نقطه.
        </h6>
        <Stepper step={props.step} />
        <button className="mainBtn" onClick={clickHandler}>
          ادامه
        </button>
        <Link to="/loginOrRegister" className="startApp link">شروع برنامه</Link>
      </div>
    </div>
  );
}
